import { SampleBoardMaterialRecipeItem } from "@app/strain/sample-boards/models/sample-board-material-recipe-item.model";
import {
    SampleBoardMeasurementInstructions
} from "@app/strain/sample-boards/models/documentation/sample-board-measurement-instructions.model";

export enum SampleBoardItemStatus {
    ValidationPending = 1,
    ValidationInProgress = 2,
    AvailableInStock = 3,
    Destroyed = 4
}

export class SampleBoardItem {
    id?: number;
    code: string;
    status: SampleBoardItemStatus;
    materialItems: SampleBoardMaterialRecipeItem[];
    availableMaterialItems?: SampleBoardMaterialRecipeItem[];
    documentation?: SampleBoardMeasurementInstructions;

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.code = entry?.code ? entry.code : null;
        this.status = entry?.status as SampleBoardItemStatus;
        this.materialItems = entry?.materials ? entry?.materials.map((ntry) => new SampleBoardMaterialRecipeItem(ntry)) : [];
        this.availableMaterialItems = entry?.availableMaterials
            ? entry.availableMaterials.map((mat: any) => new SampleBoardMaterialRecipeItem(mat))
            : undefined;
        this.documentation = entry?.documentation ? new SampleBoardMeasurementInstructions(entry.documentation) : null;
    }
}
